var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news" }, [
    _c(
      "header",
      [
        _c("van-icon", {
          attrs: { name: _vm.isDirection ? "arrow" : "arrow-left" },
          on: {
            click: function($event) {
              return _vm.$router.push({
                path: "/college",
                query: {
                  isApp: _vm.$route.query.isApp,
                  language: _vm.$route.query.language
                }
              })
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "commont_header" }, [
        _c("div", { staticClass: "header_content" }, [
          _c("b", [
            _vm._v(_vm._s(_vm.$t("300183")) + "(" + _vm._s(this.length) + ")")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("300186")))])
        ])
      ]),
      _vm._v(" "),
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "commont_body" },
            [
              _c(
                "van-list",
                {
                  attrs: { "loading-text": _vm.text, finished: _vm.finished },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading"
                  }
                },
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            path: "/college_detail",
                            query: {
                              id: item.id,
                              path: "/dataPage",
                              isApp: _vm.$route.query.isApp,
                              language: _vm.$route.query.language
                            }
                          })
                        }
                      }
                    },
                    [
                      item.id
                        ? _c("dl", [
                            _c("dt", [
                              _c("img", { attrs: { src: item.imgs, alt: "" } })
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _c("p", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "commont_content" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.htmlToString(item.content)) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              item.content
                                ? _c("p", { staticClass: "more" }, [
                                    _vm._v("(" + _vm._s(_vm.$t("300188")) + ")")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "time" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.parsetime(
                                        item.releaseTime,
                                        "{y}/{m}/{d}"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "nodata" },
            [
              _c(
                "van-empty",
                {
                  staticClass: "custom-image",
                  attrs: { description: _vm.$t("300108") }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-jilu1" } })]
                  )
                ]
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-610c2d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610c2d1c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/college/dataPage.vue
// module id = hiei
// module chunks = 0